import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71bd83ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "field-group",
  "data-group": "1"
}
const _hoisted_2 = { class: "field" }
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('applyFilters'))),
        class: "btn btn-blue",
        disabled: _ctx.isDisabled ? 'disabled' : null,
        style: {"cursor":"pointer"}
      }, _toDisplayString(_ctx.$t("search.apply_btn")), 9, _hoisted_3)
    ])
  ]))
}